module.exports = __webpack_public_path__ + "img/car-C-2.5991c4cd.jpg";